export const isTestMaster = () => {
  const regexp = /test-master\./;
  return regexp.test(window.location.hostname);
};

export const isReleaseMaster = () => {
  const regexp = /release-master\./;
  return regexp.test(window.location.hostname);
};

export const isDdev = () => {
  const regexp = /\.ddev\.site/;
  return regexp.test(window.location.hostname);
};

export const isPreviewSystem = () =>
  isDdev() || isReleaseMaster() || isTestMaster();
